import React from 'react';
import CustomersListing from './components/listing';

const Customers = () => {
  return <CustomersListing />
}

export default Customers;